"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Map to promises and resolve sequentially.
 *
 * @Param {Array} array       = The items to map over.
 * @Param {Function} callback = The callback to use when mapping.
 *
 */
function promiseSequentially(array, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        // eslint-disable-next-line max-len
        return array.reduce((promise, item, i) => __awaiter(this, void 0, void 0, function* () { return promise.then(() => __awaiter(this, void 0, void 0, function* () { return callback(item, i); })); }), Promise.resolve());
    });
}
exports.promiseSequentially = promiseSequentially;
//# sourceMappingURL=promise-sequentially.js.map